import React, { useEffect, useRef, useState } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Colors } from 'mm-theme-configuration/dist/interfaces';
import { TYPOGRAPHY_SIZE } from 'mm-theme-configuration/dist/consts';
import { getStyleBySize } from '../../../../../typography/semanticTags/semanticTags.utils';
import { TranslatedFontSize } from '../../../../../theming/fontSizeTranslator';
import { useTheme } from '../../../../../theming/useTheme';
import { NavigationLink } from '../oldHeader/primaryHeader/PrimaryHeader';
import { MoreIcon } from '../../../../partials/icon/icons';
import { Icon } from '../../../../partials/icon/Icon';
import { getFillAndStrokeIconStyle } from './header.util';
import { Link } from '../../../../partials/link/Link';


interface MegaMenuProp {
  megaMenu: NavigationLink[];
  moreIconColor: string;
}

const getLinksStyle = (colors: Colors) => {
  return StyleSheet.create({
    menuWrapper: {
      display: 'flex',
      padding: '24px',
      position: 'absolute',
      top: '75px',
      gap: '24px',
      zIndex: 10,
      boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.25)',
      backgroundColor: colors.white,
      textTransform: 'none',
    },
    columnWrapper: {
      display: 'flex',
      flexDirection: 'row',
    },
    linksAndTitle: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
    linksList: {
      listStyleType: 'none',
      flex: '1',
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column',
      gap: '4px',
      maxHeight: '230px',
      flexWrap: 'wrap',
    },
    title: {
      // @ts-ignore
      fontWeight: '700 !important',

    },
    link: {
      color: colors.darkGrey,
      display: 'flex',
      flexWrap: 'wrap',
      position: 'relative',
      alignItems: 'center',
      textDecoration: 'none',
      width: '150px',
    },
    liHover: {
      ':hover': {
        color: colors.primary,
      },
    },
    divder: {
      width: '1px',
      backgroundColor: colors.grey,
      padding: '24px 0',
    },
  });
};

export const MegaMenu: React.FunctionComponent<MegaMenuProp> = ({ moreIconColor, megaMenu }) => {
  const iconStyle = getFillAndStrokeIconStyle(moreIconColor, moreIconColor);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { colors, fontSizesStyles }: { colors: Colors; fontSizesStyles: TranslatedFontSize } = useTheme();
  const fontStyle = getStyleBySize(fontSizesStyles, { fontSizeSmall: TYPOGRAPHY_SIZE.TINY, fontSizeMedium: TYPOGRAPHY_SIZE.TINY, fontSizeLarge: TYPOGRAPHY_SIZE.TINY });
  const style = getLinksStyle(colors);
  const menuRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (menuRef.current && event.target instanceof Node) {
        if (!menuRef.current.contains(event.target)) {
          setIsMenuOpen(false);
        }
      }
    };
    if (isMenuOpen) {
      document.addEventListener('click', handleClick);
    } else {
      document.removeEventListener('click', handleClick);
    }

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [isMenuOpen]);

  return (
    <>
      <Icon icon={MoreIcon} additionalStyle={iconStyle} onClick={toggleMenu} />
      {isMenuOpen
      && (
      <div ref={menuRef} className={css(style.menuWrapper)}>
        {megaMenu.map((navigationLink: NavigationLink, index: number) => {
          return (
            <div key={index} className={css(style.columnWrapper)}>
              <div className={css(style.linksAndTitle)}>
                <Link key={index} className={css(style.title, style.link, fontStyle)} href={navigationLink.link.href}>
                  <span>{navigationLink.link.text}</span>
                </Link>
                <ul className={css(style.linksList)}>
                  {navigationLink.children?.map((child: NavigationLink, key: number) => {
                    return (
                      <li key={key}>
                        <Link className={css(style.link, style.liHover, fontStyle)} href={child.link.href}>
                          <span>{child.link.text}</span>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
              {(index < megaMenu.length - 1) && <span className={css(style.divder)} />}
            </div>
          );
        })}
      </div>
      )}
    </>
  );
};
